(function ($) {
	"use strict";

	window.isoBundlePlugin = function () {		
        $('body').on('click', ".quickview-gallery-lightbox", function(e) {
            e.preventDefault();
            var el = $(this)[0];
            $(this).attr('href', $(this).attr('href') + "#" + $(this).data('hash'));

			el.lightbox = new IframeLightbox(el, {
				onCreated: function () {},
				onLoaded: function () {
					setTimeout(function() {
						resizeQuickViewIframe();
					}, 10);

					window.addEventListener("resize", resizeQuickViewIframe);

                    var iframe = document.querySelector(".iframe-lightbox");
					if (iframe) {			
						el.dataset.class.split(" ").forEach(function(className) {
							iframe.classList.add(className);
						});
					}
				},
				onError: function () {},
				onClosed: function () {
					window.removeEventListener("resize", resizeQuickViewIframe);
				},
				scrolling: false /* default: false */,
				rate: 1 /* default: 500 */,
			});
            el.lightbox.open();
        });

		$(".mini-stories .story-thumb").each(function () {
			var $storyThumb = $(this);
			$.ajax({
				url: "https://media.wave.si/media.php?get_files&commentId=" + $(this).data("commentId"),
				dataType: "json",
				success: function (data) {
					if (data.length > 0) {
						var thumbAdded = false;
						if (typeof data[0].videos !== "undefined") {
							data[0].videos.forEach(function (el, index) {
								if (typeof data[1][index] !== "undefined" && thumbAdded === false) {
									var videoThumb = data[1][index];
									thumbAdded = true;
									$storyThumb.attr("style", "background-image: url(" + videoThumb + ")");
								}
							});
						}
						if (typeof data[0].images !== "undefined" && thumbAdded === false) {
							data[0].images.forEach(function (el, index) {
								var imageUrl = el.split("/");
								imageUrl.splice(imageUrl.length - 1, 0, "image_thumbnails");
								imageUrl = imageUrl.join("/");
								$storyThumb.attr("style", "background-image: url(" + imageUrl + ")");
								thumbAdded = true;
							});
						}
					}
				},
			});
		});

		$('.mini-stories').on('click', function() {
			$('body, html').animate({
				'scrollTop': $('.iso-reviews').length ? $('.iso-reviews').offset().top : 0
			})
		});

		function peopleWatchingSnarl() {
			var $allTimesSalesEl = $('.all-time-sales');
			if($allTimesSalesEl.length) {
				var peopleWatching = $allTimesSalesEl.data('peopleWatching');
				var text = $allTimesSalesEl.data('peopleWatchingText');

				if(parseInt(peopleWatching) > 0) {
					var id = Snarl.addNotification({
						text: ' ',
						icon: "<span class='snarl eyes-emoji'></span>",
						dismissable: false,
						timeout: 4000
					});
					$('#snarl-notification-'+id).find('.snarl-text').html(text);
					$('#snarl-notification-'+id).addClass('people-watching');
				}
			}
			setTimeout(stockNotificationSnarl, 8000);
		}

		function stockNotificationSnarl() {
			var $howManyBundlesLeftEl = $('.how-many-bundles-left');
			if($howManyBundlesLeftEl.length) {
				var text = $howManyBundlesLeftEl.find('.text').text();

				var id = Snarl.addNotification({
					text: ' ',
					icon: "<span class='snarl warning-emoji'></span>",
					dismissable: false,
					timeout: 4000
				});
				$('#snarl-notification-'+id).find('.snarl-text').html(text);
				$('#snarl-notification-'+id).addClass('stock-notification');
			}

			setTimeout(pauseBetweenNotifications, 14000);
		}

		function pauseBetweenNotifications() {
			peopleWatchingSnarl();
		}

		setTimeout(peopleWatchingSnarl, 5000);
	};
})(jQuery);
var _isobundle = new isoBundlePlugin();
